import { render, staticRenderFns } from "./newcheckoff.vue?vue&type=template&id=394a3422"
import script from "./newcheckoff.vue?vue&type=script&lang=js"
export * from "./newcheckoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports